/* 문화포럼 일정 등록 페이지 */import Box from '@mui/material/Box';
import React, {useEffect, useRef, useState} from 'react';
import {constance} from '../../common/constance/constance';
import Stack from '@mui/material/Stack';
import {config} from '../../common/config/config';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {styles} from '../../common/style';
import {
    Button,
    MenuItem,
    MenuList,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import {common} from '../../common/common';
import {Book} from "../../interface/book.interface";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import moment from "moment";
import {DateTime} from "luxon";
import {isMobile} from "react-device-detect";
import {Attendance} from "../../interface/attendance.interface"; // css import


interface State {
    dateTime: number,
    attendanceList: String[],
    attendanceWinningHistoryList: Attendance[],
}

function AttendanceCalender() {
    const [state, setState] = useState<State>({
        dateTime: new Date().getTime(),
        attendanceList: [],
        attendanceWinningHistoryList: [],
    });


    useEffect(() => {
        axios.get(constance.api.getAttendanceList, {
            params: {
                dateTime: state.dateTime
            }
        }).then(value => {
            console.log(value);
            let attendanceList = value.data.attendanceList.map((attendance: Attendance) => {
                return attendance.formatFullDate;
            })
            setState({
                ...state,
                attendanceList: attendanceList,
                attendanceWinningHistoryList: value.data.attendanceWinningHistoryList
            })
        })
    }, [state.dateTime]);

    function handleClick(e: any) {
        console.log(e);
        if (e.view == 'month') {
            setState({
                ...state,
                dateTime: e.activeStartDate.getTime()
            })

        }
    }


    let fontSize: any = isMobile ? "subtitle2" : "subtitle1";

    return (
        <>
            <Stack sx={{width: 1, display: 'flex', p: 1, alignItems: 'center', justifyContent: 'center'}}>
                <Stack sx={{
                    display: 'flex',
                    pt: 3,
                    width: 1,
                    maxWidth: config.maxWidth,
                    justifyContent: 'center',
                    alignItems: 'center',
                    '.react-calendar__navigation__label__labelText': {
                        fontWeight: 'bold',
                        fontSize: 'large',
                    },
                    '.react-calendar': {
                        width: 1,
                        p: 2,
                        borderRadius: 2,
                        border: '0px',
                    },
                    '.react-calendar button': {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    },
                    '.react-calendar__tile': {
                        height: 80,
                        border: '1px dashed #a1a1a13d',
                    },
                    'abbr': {
                        fontWeight: 'bold',
                    },
                    '.dot': {
                        borderRadius: '50%',
                        display: 'flex',
                        ml: 0,
                        position: 'absolute',
                        top: -3,
                        left: -24,
                        border: '6px dashed #f87171',
                        height: 34,
                        width: 34
                    },
                    // '.react-calendar__tile--now' : {
                    //     background: '#ffecec',
                    // },
                }}>
                    <Paper>
                    <Calendar onViewChange={handleClick}
                        // onChange={onChange}
                              formatDay={(locale, date) => moment(date).format("DD")}
                        // value={value}
                              tileContent={({date, view}) => {
                                  console.log(date);
                                  console.log(DateTime.fromMillis(date.getTime()).toFormat('yyyy-MM-dd'));
                                  let v: string = DateTime.fromMillis(date.getTime()).toFormat('yyyy-MM-dd');
                                  if (view == "month" && state.attendanceList.includes(v)) {
                                      return (
                                          <Box sx={{
                                              display: 'flex',
                                              height: 30,
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              position: 'relative'
                                          }}>
                                              <Box className="dot"/>
                                              <Typography variant={'caption'}
                                                          sx={{
                                                              position: 'absolute',
                                                              width: 50,
                                                              left: -32,
                                                              bottom: -17
                                                          }}>출석</Typography>
                                          </Box>
                                      );
                                  } else {
                                      return <></>
                                  }
                              }}
                    />
                    </Paper>

                    <Stack sx={{display: 'none', mt: 3, width: 1, alignItems: 'center', justifyContent: 'center'}}>
                        {
                            state.attendanceWinningHistoryList && state.attendanceWinningHistoryList.length > 0 ?
                                <TableContainer component={Paper} sx={{maxWidth: 500}}>
                                    <Table sx={{minWidth: 300}} size={'medium'} aria-label="a dense table">
                                        <TableHead>
                                            <TableRow sx={{'th': {padding: '16px'}, width: 1}}>
                                                <TableCell align="center">
                                                    <Typography variant={fontSize}>일자</Typography></TableCell>
                                                <TableCell align="center">
                                                    <Typography variant={fontSize}>부서</Typography></TableCell>
                                                <TableCell align="center">
                                                    <Typography variant={fontSize}>당첨자</Typography></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                state.attendanceWinningHistoryList.map((value, index) => {
                                                    return <TableRow key={index}
                                                                     sx={{
                                                                         width: 1,
                                                                         '&:last-child td, &:last-child th': {border: 0},
                                                                         'td': {padding: '8px'},
                                                                         ':hover': {
                                                                             background: styles.tableHoverColor,
                                                                         },
                                                                         transition: styles.transition,
                                                                     }}
                                                    >
                                                        {/* 게시글 번호 */}
                                                        <TableCell align="center" sx={{width: 0.3}}>
                                                            <Typography> {value.formatMonthDate} </Typography>
                                                        </TableCell>
                                                        <TableCell align="center" sx={{width: 0.4}}>
                                                            <Typography> {value.user.departmentName} </Typography>
                                                        </TableCell>
                                                        <TableCell align="center" sx={{width: 0.3}}>
                                                            <Typography> {value.user.name} </Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                })
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                :
                                <Paper sx={{width: 1, p: 2, maxWidth: 920, display: 'flex', justifyContent: 'center'}}>
                                    <Typography> 이벤트 당첨자가 존재하지 않습니다.</Typography>
                                </Paper>
                        }


                    </Stack>
                </Stack>


            </Stack>
        </>
    );
};

export default AttendanceCalender;
